<div class="tree-view">
    <form class="tree-view--search">
        <input type="text" class="tree-view--search-input" placeholder="Recherche rapide..." (keyup)="search($event.target.value)"/>
        <button mat-icon-button type="submit" class="tree-view--search-btn no-hover">
            <mat-icon svgIcon="magnify"></mat-icon>
        </button>
    </form>
    <div class="tree-view--scrollable">
        <ng-container *ngIf="items$ | async as items;else treeLoading">
            <mat-tree *ngIf="items.length;else noItems" [dataSource]="items" [treeControl]="treeControl" class="tree">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <li
                        class="mat-tree-node tree--item"
                        [class.tree--selected]="isSelected(node)"
                        [class.tree--legacy]="node.type === 'cell' && node.tags?.includes('legacy-offers')"
                        >
                        <span (click)="select(node)" class="tree--selectable">
                            <img *ngIf="node.avatar; else defaultIcon" [src]="node.avatar" [alt]="node.name" class="tree--type-icon"/>
                            <ng-template #defaultIcon>
                                <mat-icon class="tree--type-icon" [svgIcon]="node.icon"></mat-icon>
                            </ng-template>
                            <span [innerHTML]="node.name | highlight: currentSearchFilter"></span>
                            <mat-chip-listbox *ngIf="node.type === 'cell' && node.tags?.includes('legacy-offers')" class="tree--legacy-label">
                                <mat-chip disableRipple class="readonly-chip">Legacy</mat-chip>
                            </mat-chip-listbox>
                        </span>
                    </li>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <li>
                        <div
                            class="mat-tree-node tree--item"
                            [class.tree--selected]="isSelected(node)">
                            <button mat-icon-button matTreeNodeToggle
                                    [attr.aria-label]="'toggle ' + node.name">
                                <mat-icon class="mat-icon-rtl-mirror" [svgIcon]="treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'">

                                </mat-icon>
                            </button>
                            <span (click)="select(node)" class="tree--selectable">
                                <img *ngIf="node.avatar; else defaultIcon" [src]="node.avatar" [alt]="node.name" class="tree--type-icon"/>
                                <ng-template #defaultIcon>
                                    <span *ngIf="node.icon.startsWith('mdi-');else materialDesignIcon" [class]="'mdi tree--type-icon ' + node.icon"></span>
                                    <ng-template #materialDesignIcon>
                                        <mat-icon class="tree--type-icon" [svgIcon]="node.icon"></mat-icon>
                                    </ng-template>
                                </ng-template>
                                <span [innerHTML]="node.name | highlight: currentSearchFilter"></span>
                            </span>
                        </div>
                        <ul class="tree-sub" [class.tree--invisible]="!treeControl.isExpanded(node)">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                    </li>
                </mat-nested-tree-node>
            </mat-tree>
            <ng-template #noItems>
                <syn-message-box class="organization-tree-empty-message" color="info" leftIcon="information-outline">
                    Aucun élèment ne correspond à ces critères.
                </syn-message-box>
            </ng-template>
        </ng-container>
        <ng-template #treeLoading>
            <div fxLayout="row" fxLayoutAlign="center center">
                <mat-spinner diameter="24" color="accent"></mat-spinner>
            </div>
        </ng-template>
    </div>
</div>
